import { MenuItemType } from './MenuItemType';
import { Mapper, ReadOnly } from 'module/Common';

export type MenuItemSocialLinks = ReadOnly<MenuItemSocialLinks.Shape>;

export namespace MenuItemSocialLinks {
  export interface Shape {
    type: MenuItemType;
    facebook: string;
    instagram: string;
    linkedin: string;
  }

  const create = (input: MenuItemSocialLinks) => input;

  export const mapper = Mapper.mapSchema(
    {
      acf_fc_layout: Mapper.exact(MenuItemType.SocialLinks),
      facebook: Mapper.str,
      instagram: Mapper.str,
      linkedin: Mapper.str,
    },
    ({ acf_fc_layout, ...other }) => create({ ...other, type: acf_fc_layout })
  );

  export const getFacebookLink = (model: MenuItemSocialLinks): string => model.facebook;
  export const getInstagramLink = (model: MenuItemSocialLinks): string => model.instagram;
  export const getLinkedInLink = (model: MenuItemSocialLinks): string => model.linkedin;
}



// WEBPACK FOOTER //
// ./src/module/Model/Menu/item/MenuItemSocialLinks.ts